import { createFileRoute } from "@tanstack/react-router";
import InboxUnificado from "../../pages/soluciones/InboxUnificado";

export const Route = createFileRoute("/que-hacemos/inbox-unificado")({
  component: InboxUnificado,
});
